import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    height: "100%",
    backgroundColor: "#7FA88733",
    marginTop: "16px",
    // borderRadius: "10px", // Rounded corners
    "& fieldset": {
      borderColor: "transparent",
    },
    "&:hover fieldset": {
      borderColor: "#c5c5c5",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#7DA07D",
    },
  },
  "& .MuiInputBase-input": {
    padding: "12px 14px",
  },
  "& .MuiInputAdornment-root": {
    color: "#A0A0A0",
  },
});

const TextBox = ({
  placeholder,
  type = "text",
  value,
  onChange,
  icon,
  onIconClick,
  iconPosition = "end",
  error,
  helperText,
  disabled = false,
  fullWidth = true,
  className,
  maxLength,
  ...props
}) => {
  return (
    <CustomTextField
      fullWidth={fullWidth}
      type={type}
      variant="outlined"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      InputProps={{
        [iconPosition === "start" ? "startAdornment" : "endAdornment"]: icon ? (
          <InputAdornment position={iconPosition}>
            <IconButton onClick={onIconClick}>
              {typeof icon === "string" ? (
                <img src={icon} alt="icon" width="24px" height="24px" />
              ) : React.isValidElement(icon) ? (
                icon
              ) : (
                React.createElement(icon, { size: 24 })
              )}
            </IconButton>
          </InputAdornment>
        ) : null,
        ...(maxLength && { maxLength }),
      }}
      error={error}
      helperText={helperText}
      disabled={disabled}
      className={className}
      {...props}
    />
  );
};

export default TextBox;

// import React, { useState, useEffect } from 'react';
// import { Box, TextField, IconButton } from '@mui/material';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

// const Textfield = ({
//   length,
//   title,
//   placeholder,
//   keyboardType,
//   onChangeText,
//   marginHorizontal,
//   value = '', // Default empty string if value is undefined
//   isEditable = true, // Default to true
//   multiline = false,
//   height = 60,
//   secureTextEntry,
//   lock,
//   autoCapitalize,
//   setLock,
// }) => {
//   const [borderColor, setBorderColor] = useState('rgba(127, 168, 135, 0.1)');
//   const [visible, setVisible] = useState(secureTextEntry);
//   const [focused, setFocused] = useState(false);

//   const handleFocus = () => {
//     setFocused(true);
//     setBorderColor('rgba(127, 168, 135, 1)');
//   };

//   const handleBlur = () => {
//     setFocused(false);
//     setBorderColor('rgba(127, 168, 135, 0.1)');
//   };

//   const handleChangeText = (event) => {
//     const text = event.target.value;
//     if (onChangeText) {
//       onChangeText(text);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         alignItems: 'center',
//         backgroundColor: 'rgba(127, 168, 135, 0.1)',
//         height: `${height}px`,
//         borderRadius: '10px',
//         border: `1px solid ${borderColor}`,
//         flexDirection: 'row',
//         marginTop: '20px',
//         marginLeft: marginHorizontal || '25px',
//         marginRight: marginHorizontal || '25px',
//         position: 'relative',
//       }}
//     >
//       <TextField
//         fullWidth
//         variant="outlined"
//         label={title}
//         placeholder={placeholder}
//         onFocus={handleFocus}
//         onBlur={handleBlur}
//         inputProps={{
//           maxLength: length,
//           style: { paddingTop: '15px', textAlign: 'left' },
//         }}
//         InputLabelProps={{
//           shrink: true, // Keeps label floating
//         }}
//         type={visible ? 'text' : 'password'}
//         onChange={handleChangeText}
//         value={value}
//         disabled={!isEditable}
//         multiline={multiline}
//         sx={{
//           '& .MuiOutlinedInput-root': {
//             borderRadius: '10px',
//             height: '100%',
//             fontFamily: 'LeagueSpartan-SemiBold',
//             fontSize: '16px',
//             padding: '10px 15px',
//             color: 'black',
//           },
//           '& .MuiInputLabel-root': {
//             color: focused ? 'rgba(127, 168, 135, 1)' : 'rgba(0, 0, 0, 0.3)',
//           },
//         }}
//       />

//       {lock && (
//         <IconButton
//           onClick={() => setVisible(!visible)}
//           sx={{
//             position: 'absolute',
//             right: '12px',
//             top: '50%',
//             transform: 'translateY(-50%)',
//             color: 'rgba(0, 0, 0, 0.4)',
//           }}
//         >
//           {visible ? <VisibilityIcon /> : <VisibilityOffIcon />}
//         </IconButton>
//       )}
//     </Box>
//   );
// };

// export default Textfield;
